import { render, staticRenderFns } from "./ActionAssignModal.vue?vue&type=template&id=0d8f6ec9&"
import script from "./ActionAssignModal.vue?vue&type=script&lang=js&"
export * from "./ActionAssignModal.vue?vue&type=script&lang=js&"
import style0 from "./ActionAssignModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports